/**
 * api配置
 */

import { ISelectOptionItem } from '@tencent/udesign/dist';
import { HTTPMethod } from '../../../lib/http/http';
import {
  AccountType,
  IFetchAllOptions,
  IProxyRequestBody,
  IString,
} from '../../../model';
import { IConfigField } from './config-field';
import { IFieldOpt } from './field-model-extension';

// 字段 options 扩展
export enum FieldOptSource {
  api,
  mock,
}

export interface IFieldOptDataRelationKeyValue {
  readonly value: string;
  readonly label: string;
}

// 字段基础配置
export interface IFieldOptBase {
  // data为选择项，select/radio/checkbox/switch等
  // any则不做控制，类型请查阅上述组件类型的选项值
  // config字段配置页面为tsx，所以兼容所有的类型定义，包括ts、react node
  readonly data: ReadonlyArray<any>;

  // 保存键值对，主要为了在Table Body的Row中映射显示
  readonly jsonData?: IString<ISelectOptionItem>;

  // 获取默认值
  readonly dataComplete?: <T>(field: IConfigField<T>) => void;

  // 是否启用缓存，默认不启用
  // 启用缓存的命中规则：同一个 API 请求两次以上，它的请求参数[Query/Body]、URI[pathname] 一致则不会发起请求
  readonly isEnableCache?: boolean;
}

// api配置
// 请求场景
export enum FieldOptAPIReqScenes {
  normal, // 默认的，也就是当前项目的
  // normalAll, // 请求所有数据
  proxy, // 代理请求（工蜂、TAPD）
  proxyAll, // 请求所有数据
}

export interface IFieldOptAPIReqBase {
  readonly scenes?: FieldOptAPIReqScenes; // 请求场景，默认当前项目
  readonly customHeaders?: Object; // 自定义header
  readonly timeout?: number; // 请求超时时间

  // 请求参数格式化，仅对请求Body有效[POST/PUT/DELETE/PATCH]
  readonly formatReqData?: (
    data: any,
    kind: FieldOptAPIReqScenes,
    fieldOpt: IFieldOptAPI
  ) => any;
}

export interface IFieldOptAPIReqNormal extends IFieldOptAPIReqBase {
  readonly kind: FieldOptAPIReqScenes.normal;
  readonly path: string; // 接口路径，不带协议、域名
  readonly method?: HTTPMethod; // 默认 GET 请求
  readonly body?: Object; // 请求体
}

export interface IFieldOptAPIReqProxy extends IFieldOptAPIReqBase {
  readonly kind: FieldOptAPIReqScenes.proxy;
  readonly transparentReqBody: IProxyRequestBody; // 代理请求参数
  readonly platformID: number; // 平台ID
}

export interface IFieldOptAPIReqProxyAll extends IFieldOptAPIReqBase {
  readonly kind: FieldOptAPIReqScenes.proxyAll;
  readonly transparentReqBody: IProxyRequestBody;
  readonly platformID: number;
  readonly reqType: AccountType;
  readonly options?: IFetchAllOptions<any>; // 配置项
}

export interface IFieldOptAPI extends IFieldOptBase {
  readonly kind: FieldOptSource.api;
  readonly responseConfig?: IFieldOptAPIResponse;
  readonly api:
    | IFieldOptAPIReqNormal
    | IFieldOptAPIReqProxy
    | IFieldOptAPIReqProxyAll;
}

// 响应体配置
export interface IFieldOptAPIResponse {
  // 响应的处理映射关系，只能处理简单的关系
  // 复杂的响应转换请用 transformData
  readonly relationKeyValue?: IFieldOptDataRelationKeyValue;

  // 自定义数据响应的处理，比如复杂的，比如树 => 列表，对象 => 数组，数组过滤规则
  readonly transformData?:
    | string
    | ((
        data: any,
        fieldOpt: IFieldOpt
      ) => ReadonlyArray<ISelectOptionItem> | any);
}

// 固定选型值
export interface IFieldOptMock extends IFieldOptBase {
  readonly kind: FieldOptSource.mock;
  readonly responseConfig?: IFieldOptAPIResponse;
}
